module.exports = __webpack_public_path__ + "static/img/digitalize.105a74e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegrationPhone/digitalize.png
// module id = FuiM
// module chunks = 0